import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const adminLoginGuard: CanActivateFn = () => {
    const router = inject(Router);
    const authService = inject(AuthService);

    if (authService.hasUsableSession() || authService.canRefreshSession()) {
        return router.createUrlTree(['/showsList']);
    }

    authService.clearSession();
    return true;
};